import { useEffect, useRef } from "react";
import * as React from "react";
import { Col, Form, Input, InputRef, Radio, Row, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import FormHeader from "../FormHeader";
import IconButton from "../../ui/IconButton";
import { CurrencyPlaceholderName, QuoteCurrencySelectionType, QuoteCurrencyValue } from "../../../types/newLinkBuilder";

interface QuoteCurrencyFormProps {
    quoteCurrencyValue: QuoteCurrencyValue;
    setQuoteCurrencyValue: (value: QuoteCurrencyValue) => void;
    handlePlaceholder: (name: CurrencyPlaceholderName) => void;
    currencyOptions: { label: string; value: string }[];
}

const QuoteCurrencyForm: React.FC<QuoteCurrencyFormProps> = ({ quoteCurrencyValue, setQuoteCurrencyValue, handlePlaceholder, currencyOptions }) => {
    const handleQouteCurrencyChange = (field: keyof QuoteCurrencyValue, value: string) => {
        setQuoteCurrencyValue({ ...quoteCurrencyValue, [field]: value });
    }


    return (
        <>
            <FormHeader title="Quote Currency" />
            <Form.Item name={"quoteCurrency"}>
                <Radio.Group
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '20px',
                    }}
                    options={[{
                        value: QuoteCurrencySelectionType.Value,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Value</span>
                                </Col>

                                <Col span={18} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <Select
                                        placeholder="Currency"
                                        disabled={quoteCurrencyValue.selected === QuoteCurrencySelectionType.CellReference}
                                        value={quoteCurrencyValue.currency}
                                        onChange={(value) => handleQouteCurrencyChange("currency", value || "")}
                                        style={{ width: "100%" }}
                                        onClick={(e) => e.preventDefault()}
                                        options={currencyOptions}
                                    />
                                </Col>

                            </Row>
                        )
                    }, {
                        value: QuoteCurrencySelectionType.CellReference,
                        label: (
                            <Row
                                align={"middle"}
                            >
                                <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <span>Cell Reference</span>
                                </Col>

                                <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                                    <Input
                                        placeholder="Cell Reference"
                                        disabled={quoteCurrencyValue.selected === QuoteCurrencySelectionType.Value}
                                        value={quoteCurrencyValue.currencyCellReference}
                                        onChange={(e) => handleQouteCurrencyChange("currencyCellReference", e.target.value)}
                                    />
                                </Col>

                                <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                                    <IconButton
                                        disabled={quoteCurrencyValue.selected === QuoteCurrencySelectionType.Value}
                                        icon={<UploadOutlined />}
                                        onClick={() => handlePlaceholder(CurrencyPlaceholderName.QuoteCurrencyCellReference)}
                                    />

                                </Col>
                            </Row>
                        )
                    }
                    ]}
                />
            </Form.Item>
        </>
    );
};

export default QuoteCurrencyForm;
